import { useEffect, useState } from 'react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/frontend-plugin-api';

export type RegisterCount = { key: string; count?: number };

export const REGISTERS = [
  {
    key: 'api-register',
    title: "API's van de overheid",
    shortTitle: "API's",
    summary: "Elke API uit het API-register, met specificatie en ADR-score.",
    source: 'https://apis.developer.overheid.nl',
    sourceLabel: 'apis.developer.overheid.nl',
    addUrl: 'https://apis.developer.overheid.nl/apis/toevoegen',
    addLabel: 'Een API toevoegen',
    catalogPath: '/api-docs',
    filter: { kind: 'API', 'metadata.annotations.overheid.nl/register': 'api-register' },
  },
  {
    key: 'oss-register',
    title: 'Open source van de overheid',
    shortTitle: 'Open source',
    summary: 'Repositories met een publiccode.yml uit het Open Source Register.',
    source: 'https://oss.developer.overheid.nl',
    sourceLabel: 'oss.developer.overheid.nl',
    addUrl: 'https://oss.developer.overheid.nl/repositories/toevoegen',
    addLabel: 'Een repository toevoegen',
    catalogPath: '/catalog?type=open-source',
    filter: { kind: 'Component', 'spec.type': 'open-source' },
  },
  {
    key: 'schema-register',
    title: 'Gegevensschema’s',
    shortTitle: 'Gegevensschema’s',
    summary: "JSON Schema's uit het Schema-register, om op voort te bouwen.",
    source: 'https://schemas.developer.overheid.nl',
    sourceLabel: 'schemas.developer.overheid.nl',
    addUrl: 'https://schemas.developer.overheid.nl/schemas/toevoegen',
    addLabel: 'Een schema toevoegen',
    catalogPath: '/catalog?type=json-schema',
    filter: { kind: 'Resource', 'spec.type': 'json-schema' },
  },
  {
    key: 'code-overheid',
    title: 'Code op code.overheid.nl',
    shortTitle: 'code.overheid.nl',
    summary: 'Repositories en organisaties op het overheidsbrede codeplatform.',
    source: 'https://code.overheid.nl',
    sourceLabel: 'code.overheid.nl',
    catalogPath: '/catalog?type=code-overheid',
    filter: { kind: 'Component', 'spec.type': 'code-overheid' },
  },
] as const;

export const API_STATISTICS = {
  title: 'Statistieken van het API-register',
  url: 'https://apis.developer.overheid.nl/api-statistieken',
  sourceLabel: 'apis.developer.overheid.nl',
};

export function useRegisterCounts() {
  const catalogApi = useApi(catalogApiRef);
  const [counts, setCounts] = useState<Record<string, number | undefined>>({});

  useEffect(() => {
    let active = true;
    REGISTERS.forEach(register => {
      catalogApi
        .queryEntities({ filter: register.filter, limit: 1 })
        .then(result => {
          if (active) {
            setCounts(previous => ({
              ...previous,
              [register.key]: result.totalItems,
            }));
          }
        })
        .catch(() => undefined);
    });
    return () => {
      active = false;
    };
  }, [catalogApi]);

  return counts;
}
